
import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';
import { MasterCapabilitiesList } from '../utils/LMConstants';
import { Cross2Icon } from '../icons/Icons';

function ShotListHeaderContextMenu({
  ContextLocation,
  Column,
  IsInFavorites,
  HandleColumnContext,
  onClose,                 // NEW: parent passes a close handler
}) {
  const ref = React.useRef(null);

  const handleOptionClicked = (option) => {
    HandleColumnContext(option);
    // Close after action (remove this line if you want it to stay open)
    onClose?.();
  };

  const GetSanitizedNameForHeader = (id) => {
    const [lmType, columnName] = String(id).split('$');
    const match = MasterCapabilitiesList?.find?.(c => c.key === columnName);
    const realName = match?.display ?? columnName ?? '';
    return `${lmType}'s ${realName}`;
  };

  // Close on outside click + Esc
  React.useEffect(() => {
    const onPointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('pointerdown', onPointerDown, { capture: true });
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown, { capture: true });
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="desktop-shotlist-context-menu"
      role="menu"
      aria-label="Shot list menu"
      style={{
        width:'300px',
        position: 'absolute',                // ensure absolute for the given coords
        pointerEvents: 'none',
        top: `${ContextLocation.y}px`,
        left: `${ContextLocation.x}px`,
      }}
    >
      {/* Close button */}
      <button
        type="button"
        aria-label="Close menu"
        className="modal-close-button"
        onClick={() => onClose?.()}
      >
        <Cross2Icon width='30px' height='30px' />
      </button>

      <span style={{ height: '40px', alignContent: 'center', fontWeight: 'bold' }}>
        {GetSanitizedNameForHeader(Column)}
      </span>

      {!IsInFavorites ? (
        <button className="button" style={{ marginTop: '10px', width:'auto', pointerEvents: 'all' }} onClick={() => handleOptionClicked('ADD')}>
          Add to favorites
        </button>
      ) : (
        <button className="button" style={{ marginTop: '10px', width:'auto', pointerEvents: 'all' }} onClick={() => handleOptionClicked('REMOVE')}>
          Remove from favorites
        </button>
      )}
    </div>
  );
}

export default ShotListHeaderContextMenu;